<template>
  <div class="zv-page">
    <div class="zv-content">
      <!-- <div class="zv-block" style="display:flex">
        <div class="block" style="margin-left:20px;display:flex">
          <span class="countryName">分类</span>
          <el-input placeholder="输入关键字" v-model="countryName" clearable></el-input>
        </div>

        <div style="margin-left:20px">
          <el-row>
            <el-button type="success" @click="queryData()">查询</el-button>
            <el-button type="primary">导出</el-button>
          </el-row>
        </div>
      </div> -->
      <el-button type="success" style="margin:10px 0" @click="addResponseLibraryData()">新增类型</el-button>
      <el-table
        :data="tableData"
        style="width: 100%"
        default-expand-all
        ref="dataTable"
        row-key="id"
        :tree-props="{children: 'child', hasChildren: 'haschild'}"
      >
        <el-table-column prop="id" label="编号"></el-table-column>
        <el-table-column prop="name" label="类型等级">
          <template slot-scope="scope">
            <span>{{scope.row.level == 1 ? '一级': scope.row.level == 2 ? '二级':'三级'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="category_name" label="事件类型名称"></el-table-column>
        <el-table-column prop="add_time" label="创建时间">
          <template slot-scope="scope">
            <span>{{$commFunc.formatDate(scope.row.add_time)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="update_time" label="最后更新">
          <template slot-scope="scope">
            <span>{{$commFunc.formatDate(scope.row.update_time)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="last_admin_username" label="操作人">
          <template slot-scope="scope">
            <span>{{scope.row.last_admin_username || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="editFn(scope.row)">
              编辑
            </el-button>
            <el-button v-if="scope.row.level != 3" type="text" size="small" @click="addChild(scope.row)">
              新增子分类
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
     <zv-dialog
      width="450px"
      :title="isEdit ? '修改' : '新增'"
      :showDialog.sync="showFormDialog"
      @close-dialog="closeFormDialog"
    >
      <div slot="content">
        <el-form
          ref="myForm"
          label-width="100px"
          :model="formData"
          :rules="formRules"
          status-icon
        >
          <el-form-item label="名称：" prop="category_name">
            <el-input v-model="formData.category_name" placeholder="请输入事件类型名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="上级类型：">
            <el-select v-model="formData.parent_id" placeholder="请选择">
              <el-option
                label="顶级分类"
                :value="0"
              ></el-option>
              <el-option
                v-for="item in categoryList"
                v-if="item.level != 3"
                :key="item.id"
                :label="item.level+'-'+item.category_name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="启用状态：" >
            <el-switch
              v-model="formData.status"
              :active-value='1'
              :inactive-value='0'
              >
            </el-switch>
          </el-form-item>
        </el-form>
      </div>
      <div slot="btns">
        <el-button @click="showFormDialog = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </zv-dialog>
  </div>
</template>

<script>
import api from "./api";
import addFormMixin from "@/mixins/addFormMixin";
export default {
  name: "ResponseLibrary",
  mixins: [addFormMixin],
  data() {
    return {
      showFormDialog: false,
      addressSelectData: null,
      addressItem: null,
      countryName: "",
      tableData: [],
      currentPage: 1,
      formData: {},
      categoryList: '',
      totalList: null,
      formRules: {
        category_name: {
          required: true,
          message: "事件类型名不能为空",
          trigger: "blur"
        },
        field_type: {
          required: true,
          message: "字段类型不能为空",
          trigger: "change"
        }
      },
      isEdit: false
    };
  },
  created() {
    this.getData({parent_id: 0});
    this.selectFn()
  },
  methods: {
    // 获取数据
    getData(data) {
      api
        .eventCategoryList(data)
        .then(res => {
          this.tableData = res.list;
        })
        .catch(err => {
          // console.log(err);
        });
    },
    selectFn() {
       api
        .eventCategoryList()
        .then(res => {
          this.categoryList = res.list;
        })
        .catch(err => {
          // console.log(err);
        });
    },

    submitForm() {
      this.$refs["myForm"].validate((valid) => {
        if (valid) {
          if(this.isEdit) {
            let datas = {
              id: this.formData.id,
              category_name: this.formData.category_name,
              parent_id: this.formData.parent_id,
              status: this.formData.status
            }
            api
            .eventCategoryEdit(datas)
            .then(res => {
              if(res.error_code == 0) {
                this.$message.success("修改成功!")
                this.showFormDialog = false
                this.getData({parent_id: 0})
              }
            })
            .catch(err => {
              // console.log(err);
            });
          }else {
            api
            .eventCategoryAdd(this.formData)
            .then(res => {
              if(res.error_code == 0) {
                this.$message.success("新增成功!")
                this.showFormDialog = false
                this.getData({parent_id: 0})
              }
            })
            .catch(err => {
              // console.log(err);
            });
          }
        } else {
          
        }
      });
    },

    // 新增
    addResponseLibraryData(row) {
      this.showFormDialog = true
      this.formData = {}
    },
    // 编辑
    editFn(row) {
      this.isEdit = true
      this.showFormDialog = true
      this.formData = row
    },
    // 新增子分类
    addChild(row) {
      this.showFormDialog = true
      this.formData = {
        parent_id: row.id
      }
      console.log(row)
    },

  }
};
</script>

<style lang="scss" scoped>
.pagination {
  text-align: right;
  padding: 0 20px;
}
.countryName {
  margin-right: 10px;
  width: 40px;
  justify-content: center;
  align-items: center;
  display: flex;
}
</style>